import { DataGrid, mergeSx, type DataGridProps } from '@shared/components';

import { columns } from './columns';
import { type TimeExtensionHistoryRow } from './types';

export type TimeExtensionHistoryDataGridProps = Omit<
  DataGridProps<TimeExtensionHistoryRow>,
  'columns'
>;

export default function TimeExtensionHistoryDataGrid(
  props: Readonly<TimeExtensionHistoryDataGridProps>,
) {
  const { sx, ...restProps } = props;

  return (
    <DataGrid
      {...restProps}
      columns={columns}
      disableColumnMenu
      disableRowSelectionOnClick
      rowHeight={48}
      initialState={{
        pagination: {
          paginationModel: {
            page: 0,
            pageSize: 10,
          },
        },
      }}
      pageSizeOptions={[10, 25, 50]}
      sx={mergeSx(
        (theme) => ({
          '--DataGrid-overlayHeight': '352px',
          border: `1px solid ${theme.palette.grey[300]}`,
          backgroundColor: theme.palette.background.paper,
          '.MuiDataGrid-cell': {
            p: theme.spacing(3),
            borderBottom: `1px solid ${theme.palette.grey[300]}`,
          },
          '.MuiDataGrid-columnHeaders': {
            backgroundColor: theme.palette.grey[100],
            borderBottom: `1px solid ${theme.palette.grey[300]}`,
          },
          '.MuiDataGrid-columnHeader': {
            p: theme.spacing(2.5, 3),
          },
          '> .MuiBox-root': {
            p: theme.spacing(3, 4),
            '& .MuiToolbar-root': {
              minHeight: 'unset',
              height: 'unset',
              '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
                m: 0,
              },
              '& .MuiTablePagination-actions': {
                ml: theme.spacing(1),
                '> button': {
                  p: theme.spacing(1),
                },
              },
            },
          },
        }),
        sx,
      )}
    />
  );
}
